import type { ShareProgress } from '../share-criteria-types.ts';

import { DB_CELLS, DB_ROWS, LIVE_DOC_WORDS, WHITEBOARD_OBJECTS } from './thresholds.ts';

/**
 * Pure predicate: returns whether the given normalized progress satisfies the
 * per-surface share criteria for the TWCG-2055 experiment.
 *
 * - live-doc: word-delta >= LIVE_DOC_WORDS
 * - database: (rows > DB_ROWS AND at least one cell filled) OR filled cells > DB_CELLS
 * - whiteboard: elements >= WHITEBOARD_OBJECTS
 *
 * No React, no timers — safe to reuse from any layer (including Phase 6).
 */
export function evaluateShareCriteria(progress: ShareProgress): boolean {
	switch (progress.type) {
		case 'live-doc':
			return progress.wordDelta >= LIVE_DOC_WORDS;
		case 'database':
			return (
				(progress.rows > DB_ROWS && progress.filledCells >= 1) || progress.filledCells > DB_CELLS
			);
		case 'whiteboard':
			return progress.elements >= WHITEBOARD_OBJECTS;
		default: {
			// Exhaustiveness guard: if a new content type is added to the union,
			// this line fails to compile until the switch is updated.
			const _exhaustive: never = progress;
			return _exhaustive;
		}
	}
}
